import { useState } from "react";
import Table from "../../common/Table";
import { notify } from "../../common/Toast";
import { salesOrderMaster } from "../../utlis/apiService";
import { FormFooter } from "../../common/Shared";
import Model from "../../common/Model";

const BatchTable = ({ batchItems, batchId, onClose }) => {
  const [isSaving, setIsSaving] = useState(false);
  const totalQty = batchItems.reduce(
    (sum, item) => sum + Number(item.qty || 0),
    0,
  );
  const totalWeight = batchItems
    .reduce((sum, item) => sum + Number(item.qty_Weight || 0), 0)
    .toFixed(2);

  const columns = [
    { key: "order_No", label: "SO NO." },
    { key: "cust_Name", label: "Customer" },
    { key: "dieNumber", label: "Die No." },
    { key: "currentWeight", label: "Current Weight" },
    { key: "profile_Length", label: "Cut Length" },
    { key: "qty", label: "Pcs" },
    { key: "qty_Weight", label: "Weight" },
    { key: "alloy_Name", label: "Alloy" },
    { key: "req_Delivery", label: "Dispatch Date" },
    { key: "status", label: "Days to Dispatch" },
  ];

  const handleSendToProduction = async () => {
    setIsSaving(true);
    try {
      const selectedIds = batchItems.map((item) => item.id);
      if (!selectedIds.length) {
        notify("No items in batch", "error");
        return;
      }
      await salesOrderMaster.SendToProdcution(selectedIds);
      onClose();
      notify("Batch sent to production successfully!", "success");
    } catch (error) {
      console.error("SendToProduction Error:", error);
      notify("Failed to send batch to production", "error");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Model
      isOpen={true}
      onClose={onClose}
      name="Production Batch Sheet"
      widthClass="max-w-6xl"
    >
      <div className="flex flex-col">
        {/* Summary Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 border-b border-slate-100">
          <div className="flex flex-col">
            <p className="text-[9px] text-gray-400 font-black uppercase tracking-[2px] mb-1">
              Total Quantity
            </p>
            <p className="text-[20px] font-black text-gray-800 leading-none">
              {totalQty}{" "}
              <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                pcs
              </span>
            </p>
          </div>
          <div className="flex flex-col">
            <p className="text-[9px] text-gray-400 font-black uppercase tracking-[2px] mb-1">
              Total Weight
            </p>
            <p className="text-[20px] font-black text-primary leading-none">
              {totalWeight}{" "}
              <span className="text-[10px] font-black text-primary uppercase tracking-widest">
                kg
              </span>
            </p>
          </div>
        </div>

        {/* Table */}
        <div className="p-6 border-b border-slate-100">
          <Table columns={columns} data={batchItems} showActions={false} />
        </div>

        {/* Next Batch ID */}
        <div className="px-6 py-4 border-b border-slate-100 w-full md:max-w-xs">
          <label className="block mb-2 text-[10px] font-black text-gray-400 uppercase tracking-widest">
            Next Production Batch Id
          </label>
          <div className="bg-slate-50 border border-gray-200 h-9 flex items-center px-4 text-[12px] font-black text-gray-700">
            {batchId}
          </div>
        </div>

        <FormFooter
          onCancel={onClose}
          onSubmit={handleSendToProduction}
          submitText="Send to Production"
          isSaving={isSaving}
        />
      </div>
    </Model>
  );
};

export default BatchTable;
